import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { LoginSteps } from './types';
import { setLoginStepToStorage } from '../lib/form-step-storage/form-step-storage';
import { setLoginValueToStorage } from '../lib/login-value-storage/login-value-storage';

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoginStep: (state, action: PayloadAction<LoginSteps>) => {
            const step = action.payload;
            state.currentStep = step;
            setLoginStepToStorage(step);
        },
        setLogin: (state, action: PayloadAction<string | undefined>) => {
            const login = action.payload;
            state.login = login;
            setLoginValueToStorage(login);
        },
    },
});

// Action creators are generated for each case reducer function
export const { setLoginStep, setLogin } = authSlice.actions;

export default authSlice.reducer;
